import styled from "styled-components";
export const NavStyled = styled.nav`
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
`;
